module.exports = __webpack_public_path__ + "static/media/ThumbnailStill13.1d839d96.png";